import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"sm":"12"}},[_c('CommonSettings')],1)],1),_c(VRow,[_c(VCol,{attrs:{"sm":"12"}},[_c('UserSettings')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }